/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

export const JOB_ROOM = "jobroom";
export const EXPLORE_ROOM = "exploreroom";
export const HOME_ROOM = "homeroom";
export const DELAY_ANALISYS_ROOM = "delayanalysisroom";
export const TOPOLOGY_ROOM = "topologyroom";
export const WORKSTATION_ROOM = "workstationroom";
